/**
 * Inserts a space in a string every "spaceEvery" characters. E.g. for phone numbers:
 * "12345678" => "12 34 56 78".
 * @param str
 * @param spaceEvery
 * @returns
 */
export const stringInsertSpace = (str: string, spaceEvery: number): string => {
  if (!str?.length) return '';
  if (spaceEvery < 1) throw new Error('spaceEvery must be greater than 0.');

  let res = '';

  for (let i = 0; i < str.length; i++) {
    if (i % spaceEvery === 0 && i !== 0) {
      res += ' ';
    }

    res += str[i];
  }

  return res;
};

/**
 * Inserts a string into a string at a given index.
 *
 * E.g. stringInsertValue('abde', 'c', 2) => 'abcde'
 * @param str     String to insert value into.
 * @param val     Value to insert into string.
 * @param index   Index to insert value at.
 * @returns
 */
export const stringInsertValue = (
  str: string,
  val: string,
  index: number,
): string => {
  if (!str?.length)
    throw new Error('str must be a string with length greater than 0.');

  if (index < 0 || index >= str.length) {
    throw new Error('index must be greater than 0 and less than str length.');
  }

  return `${str.slice(0, index)}${val}${str.slice(index)}`;
};

/**
 * Given an array of strings, filters away null and undefined values and returns a comma seperated list.
 * @param list
 * @returns
 */
export const commaSeperatedList = (list: (string | null | undefined)[]) => {
  return list.filter((item) => item !== null && item !== undefined).join(', ');
};
